import React from 'react'
import PropTypes from 'prop-types'
import { GGMenu } from '../../../shared/new_components/GGMenu'

const ManagersTable = ({ managers, handleReinvite, handleDelete }) => {
  return (
    <div>
      <table className='managers-table'>
        <thead>
          <tr>
            <td>{window.I18n.t('gg_golf_hub.managers_table.name')}</td>
            <td>{window.I18n.t('gg_golf_hub.managers_table.email')}</td>
            <td>{window.I18n.t('gg_golf_hub.managers_table.status')}</td>
            <td>{window.I18n.t('gg_golf_hub.managers_table.actions')}</td>
          </tr>
        </thead>
        <tbody>
          {managers.map((elem) => {
            const status = elem.status ? window.I18n.t('gg_golf_hub.managers_table.registered') : window.I18n.t('gg_golf_hub.managers_table.pending')
            const menuOptions = []
            if (!elem.status) {
              menuOptions.push({
                label: window.I18n.t('gg_golf_hub.managers_table.reinvite'),
                value: 'reinvite',
                icon: 'arrows-rotate-o',
                usePro: true,
              })
            }
            if (elem.canDelete) {
              menuOptions.push({
                label: window.I18n.t('gg_golf_hub.managers_table.delete'),
                value: 'delete',
                icon: 'trash-can-o',
                usePro: true,
                danger: true,
              })
            }
            const handleActionSelect = (value) => {
              if (value === 'reinvite') {
                handleReinvite(elem.id)
              } else if (value === 'delete') {
                handleDelete(elem.id)
              }
            }
            return (
              <tr key={elem.id}>
                <td className='name'>
                  {elem.fullName}
                </td>
                <td>
                  {elem.email}
                </td>
                <td>
                  {status}
                </td>
                <td className='actions'>
                  {menuOptions.length > 0 && <GGMenu options={menuOptions} onSelect={handleActionSelect} position='left' />}
                </td>
              </tr>
            )
          })
          }
        </tbody>
      </table>
    </div>

  )
}

ManagersTable.propTypes = {
  managers: PropTypes.array,
  handleReinvite: PropTypes.func,
  handleDelete: PropTypes.func,
}

export default ManagersTable
